import { useState } from 'react';

import type { TView } from '@shared/types/view';
import type { ColumnOrderState, Updater } from '@tanstack/react-table';

const resolveOrderFallback = (
  view?: TView,
  initialOrder: string[] = []
): ColumnOrderState => {
  const viewOrdering = view?.visible_static_fields?.ordering || [];
  return viewOrdering.length ? viewOrdering : initialOrder;
};

export const useColumnOrder = (view?: TView, initialOrder: string[] = []) => {
  // Keep empty until the user/view-switch writes state so async view load can win.
  const [columnOrder, setColumnOrder] = useState<ColumnOrderState>([]);

  const fallbackOrder = resolveOrderFallback(view, initialOrder);

  const derivedColumnOrder = columnOrder?.length
    ? columnOrder
    : fallbackOrder;

  function onColumnOrderChange(colFnOrValue: Updater<ColumnOrderState>) {
    const cols =
      typeof colFnOrValue === 'function'
        ? colFnOrValue(derivedColumnOrder)
        : colFnOrValue;
    setColumnOrder(cols);
  }

  return {
    columnOrder: derivedColumnOrder,
    onColumnOrderChange,
  };
};
